import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import type { InspectionCheckOverrideType } from '@/types';

interface OverrideTypeFieldProps {
  value: InspectionCheckOverrideType | '';
  onChange: (value: InspectionCheckOverrideType) => void;
  disabled?: boolean;
}

function OverrideTypeField({
  value,
  onChange,
  disabled = false,
}: OverrideTypeFieldProps): React.JSX.Element {
  return (
    <FormControl fullWidth>
      <InputLabel id='override-type-group'>Reason</InputLabel>
      <Select
        labelId='override-type-group'
        label='Reason'
        value={value}
        onChange={(e) =>
          onChange(e.target.value as InspectionCheckOverrideType)
        }
        disabled={disabled}
      >
        <MenuItem value='deviation'>Intentional Deviation</MenuItem>
        <MenuItem value='not_applicable'>
          Not Applicable To This Document
        </MenuItem>
        <MenuItem value='incorrect'>Incorrect Evaluation</MenuItem>
      </Select>
    </FormControl>
  );
}

export default OverrideTypeField;
